import React, {
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import { SimpleDialog } from "simple-ui-components";

import { IframeStyled } from "../../theme";
import { getTranslation } from "../languageProvider";

export const ViewPDF = forwardRef((props, ref) => {
  const { Dialog, DialogBody } = SimpleDialog;

  const [open, setOpen] = useState(false);
  const [order, setOrder] = useState("");

  // trigger from props
  useImperativeHandle(ref, () => ({
    Detail(detail) {
      setOpen(true);
      setOrder(detail);
    },
  }));
  const handleClose = useCallback(() => setOpen(false), []);
  return (
    <>
      {open && (
        <Dialog
          theme="default"
          size="md"
          close={handleClose}
          open={open}
          title={getTranslation("0171")}
        >
          <DialogBody>
            {order && (
              <IframeStyled
                src={order.filename}
                title={order.originalFilename}
                frameBorder="1"
                scrolling="auto"
              />
            )}
          </DialogBody>
        </Dialog>
      )}
    </>
  );
});
